"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _2RUCRSRFcjs = require('./2RUCRSRF.cjs');

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return _2RUCRSRFcjs.createDisclosureStore.call(void 0, props);
}



exports.createDialogStore = createDialogStore;
